export default "__VITE_ASSET__2caa2110__"